exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#reverse-image-search-dropzone[data-v-0ecafd33]{min-height:150px}#reverse-image-search-add-files[data-v-0ecafd33]{padding-top:52px}.dz-uploaded-file[data-v-0ecafd33]{cursor:default}.dz-thumbnail[data-v-0ecafd33]{display:block;width:auto;height:100px;margin-right:unset}.dz-thumbnail img[data-v-0ecafd33]{max-height:98px}.dz-uploaded-file .dz-thumbnail .view-image-icon[data-v-0ecafd33]{left:0;top:0;bottom:0;right:0;margin:auto;width:36px;height:38px}.dz-upload-info[data-v-0ecafd33]{position:static;display:block}.dz-progress[data-v-0ecafd33]{width:calc(100% - 20px)}", ""]);

// exports
